'use memo';

import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';
import { featureFlags } from '@/lib/env';

/**
 * Item Ledger（品目台帳）一覧画面のレイアウト。
 *
 * FE-1 で配線した ITEM_LEDGER feature flag が無効な環境では 404 にする。
 * 値の出し分け（prd は非表示 / stg・demo・dev・local は表示）は backend の
 * feature-flag-definitions.ts が単一の正であり、FE は /v2/session が返す値を参照するだけ。
 *
 * ヘッダー（緑のロゴ + "Item" タイトル）は `_list/-components/ItemLedgerListPage.tsx`
 * 側で描画する。Figma モック準拠で「PRC | Item」型の二重ヘッダーは表示しない。
 */
export const Route = createFileRoute('/_staff/item-ledger/_list')({
  beforeLoad: () => {
    if (!featureFlags.check('ITEM_LEDGER')) {
      throw notFound();
    }
  },
  component: Layout
});
function Layout() {
  return <div className="flex flex-col">
      <Outlet />
    </div>;
}